import useCampaign from "Hooks/useCampaign";
import { CSSProperties } from "react";
import { clsx, styx } from "modules/Utils";
import CardSymphony from "elements/CardSymphony";
import InputSymphony, { SelectOptionItem } from "elements/InputSymphony";
import { CallToActionType } from "modules/Campaign";

export const TIKTOK_CALL_TO_ACTION_TYPES: CallToActionType[] = [
    { value: "APPLY_NOW", label: "Apply now" },
    { value: "BOOK_NOW", label: "Book now" },
    { value: "CALL_NOW", label: "Call now" },
    { value: "CONTACT_US", label: "Contact us" },
    { value: "DOWNLOAD_NOW", label: "Download" },
    { value: "EXPERIENCE_NOW", label: "Experience now" },
    { value: "GET_QUOTE", label: "Get quote" },
    { value: "GET_SHOWTIMES", label: "Get showtimes" },
    { value: "GET_TICKETS_NOW", label: "Get tickets now" },
    { value: "INSTALL_NOW", label: "Install now" },
    { value: "INTERESTED", label: "Interested" },
    { value: "LEARN_MORE", label: "Learn more" },
    { value: "LISTEN_NOW", label: "Listen now" },
    { value: "ORDER_NOW", label: "Order now" },
    { value: "PLAY_GAME", label: "Play game" },
    { value: "PREORDER_NOW", label: "Pre-order now" },
    { value: "READ_MORE", label: "Read more" },
    { value: "SEND_MESSAGE", label: "Send message" },
    { value: "SHOP_NOW", label: "Shop now" },
    { value: "SIGN_UP", label: "Sign up" },
    { value: "SUBSCRIBE", label: "Subscribe" },
    { value: "VIEW_NOW", label: "View now" },
    { value: "VIEW_PROFILE", label: "View profile", note: "Only supported in ads with the advertising objective ENGAGEMENT" },
    { value: "VISIT_STORE", label: "Visit store" },
    { value: "WATCH_LIVE", label: "Watch LIVE", note: "Only supported in LIVE ads" },
    { value: "WATCH_NOW", label: "Watch now" },
    { value: "JOIN_THIS_HASHTAG", label: "Join this hashtag", note: "Only supported in R&F ads" },
    // { value: "SHOOT_WITH_THIS_EFFECT", label: "Shoot with this effect", note: "Only supported in R&F ads" },
    // { value: "VIEW_VIDEO_WITH_THIS_EFFECT", label: "View video with this effect", note: "Only supported in R&F ads" }
];

export const FACEBOOK_CALL_TO_ACTION_TYPES: CallToActionType[] = [
    { value: 'CONTACT_US', label: 'Contact Us' },
    { value: 'DOWNLOAD', label: 'Download' },
    { value: 'LEARN_MORE', label: 'Learn More' },
    { value: 'SHOP_NOW', label: 'Shop Now' },
    { value: 'SIGN_UP', label: 'Sign Up' },
    { value: 'LISTEN_NOW', label: 'Listen Now' },
    { value: 'WATCH_MORE', label: 'Watch More' }
];

interface AdCallToActionSelectorCampaignProps {
    className: string;
    style?: CSSProperties;
    variant?: 'tiktok' | 'facebook';
}

const AdCallToActionSelectorCampaign = ({
    className,
    style,
    variant = 'tiktok'
}: AdCallToActionSelectorCampaignProps) => {
    const {
        callToAction,
        setCallToAction,
    } = useCampaign();

    const getCallToActionLabel = (): string => {
        switch (variant) {
            case 'tiktok':
                return TIKTOK_CALL_TO_ACTION_TYPES.find(type => type.value === callToAction.value)?.label || '';
            case 'facebook':
                return FACEBOOK_CALL_TO_ACTION_TYPES.find(type => type.value === callToAction.value)?.label || '';
        }
    }

    const formatCallToActionOptions = (): SelectOptionItem[] => {
        switch (variant) {
            case 'tiktok':
                return TIKTOK_CALL_TO_ACTION_TYPES.map(type => ({
                    value: type.value,
                    title: type.label,
                    object: type
                }));
            case 'facebook':
                return FACEBOOK_CALL_TO_ACTION_TYPES.map(type => ({
                    value: type.value,
                    title: type.label,
                    object: type
                }));
        }
    }
    return (
        <CardSymphony
            className="adCallToActionSelectorCampaignComponent"
            title="Call-to-Action"
            subtitle={variant === 'tiktok' ?
                'Select a call-to-action for your ad - when a user clicks this, they will be sent to your TikTok Profile.'
                :
                'Select a call-to-action for your ad - when a user clicks this, they will be sent to your Instagram Page.'
            }
            size="small"
            isPadding16
        >
            <InputSymphony
                className="ctaInput"
                value={getCallToActionLabel()}
                options={formatCallToActionOptions()}
                onOptionSelect={(option) => setCallToAction(option.object as CallToActionType)}
                isSelectDropdown
            />
        </CardSymphony>
    )
}

const sty: Record<string, CSSProperties> = {
    ctaContainer: {
        padding: '16 24'
    },
    ctaTitle: {
        fontSize: 16,
        fontWeight: 500,
        marginBottom: 8
    },
    ctaDescription: {
        fontSize: 14,
        color: '#6B7280',
        marginBottom: 16
    }
}

export default AdCallToActionSelectorCampaign;